/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class SystemManagerSystemsType {
  name: string;
  subItems: string[] = [];
  hasSubItems: boolean;

  constructor(name: string, subItem?: string, hasSubItems?: boolean) {
    this.name = name;
    if (subItem) {
      this.subItems.push(subItem);
    }

    if (hasSubItems) {
      this.hasSubItems = hasSubItems;
    }
  }
}
